/*

const pm = new PerfectMooseDecoder();
console.log(pm.decodeToJson(String('pmg20-lf02-1').toUpperCase()));


printed result:
{
  description: "Machine_type: Greg<br>Voltage: 220-240 Volt<br>Frequency: 50/60 Hertz<br>Cable_attachment_type: Loose (cable detachable from device - including plug)<br>Cable_type: F - Schuko<br>Color: Standard White<br>Pitcher_holder: Standard",
  machine_type: "Greg",
  voltage: "220-240 Volt",
  frequency: "50/60 Hertz",
  cable_attachment_type: "Loose (cable detachable from device - including plug)",
  cable_type: "F - Schuko",
  color: "Standard White",
  pitcher_holder: "Standard",
}
*/


class PerfectMooseDecoder {
  constructor() {
    this.configurator = new Map();

    this.configurator.set(
      'machine_type',
      new Map([
        ['G', { decoded: 'Greg', image: '' }],
        ['J', { decoded: 'Jack', image: '' }]
      ])
    );

    this.configurator.set(
      'pitcher_holder',
      new Map([
        ['1', { decoded: 'Standard', image: '' }],
        ['2', { decoded: 'Epic', image: '' }]
      ])
    );

    this.configurator.set(
      'voltage',
      new Map([
        ['1', { decoded: '100-127V', image: '' }],
        ['2', { decoded: '220-240V', image: '' }],
        ['3', { decoded: '200-208V', image: '' }]
      ])
    );

    this.configurator.set(
      'frequency',
      new Map([
        ['0', { decoded: '50/60Hz', image: '' }],
        ['1', { decoded: '50/60Hz', image: '' }]
      ])
    );

    this.configurator.set(
      'cable_attachment_type',
      new Map([
        ['L', { decoded: 'Loose (cable detachable from device - including plug)', image: '' }],
        ['F', { decoded: 'Fixed (cable fixed to device - including plug)', image: '' }],
        ['X', { decoded: 'Fixed (cable fixed to device - excluding plug)', image: '' }],
        ['Y', { decoded: 'Americas + Japan only fixed (cable fixed to device - excluding plug)', image: '' }]
      ])
    );

    // default plug values, further split down in getDecodedValue
    this.configurator.set(
      'cable_type',
      new Map([
        ['B', { decoded: 'B - NEMA 5-15', image: '', color: 'orange' }],
        ['D', { decoded: 'Type D', image: '', color: 'gray' }],
        ['F', { decoded: 'F - Schuko', image: '', color: 'blue' }],
        ['G', { decoded: 'G - BS1363 13A', image: '', color: 'green' }],
        ['H', { decoded: 'Type H', image: '', color: 'yellow' }],
        ['I', { decoded: 'I - AS3112 10A', image: '', color: 'red' }],
        ['J', { decoded: 'J - SN 441011 10A', image: '', color: 'purple' }],
        ['K', { decoded: 'Type K', image: '', color: 'pink' }],
        ['L', { decoded: 'Type L', image: '', color: 'brown' }],
        ['M', { decoded: 'M - BS 546 15A', image: '', color: 'black' }],
        ['N', { decoded: 'Type N', image: '', color: 'white' }],
        ['O', { decoded: 'Type O', image: '', color: 'gray' }],
        ['Z', { decoded: 'B - JIS C 8303 - NEMA 6-20', image: '', color: 'orange' }],
        ['X', { decoded: 'Supplied without plug onto cable', image: '', color: 'blue' }]
      ])
    );

    this.configurator.set(
      'color',
      new Map([
        ['01', { decoded: 'Standard Black B', image: '' }],
        ['02', { decoded: 'Standard White', image: '' }]
      ])
    );

    this.configurator.set(
      'pitcher_holder',
      new Map([
        ['1', { decoded: 'Standard', image: '' }],
        ['2', { decoded: 'Epic', image: '' }]
      ])
    );


    this.configurator.set(
      'boiler_wattage',
      new Map([
        ['20', { decoded: '2400W' }],
        ['21', { decoded: '2950W' }],
        ['30', { decoded: '2950W' }],
        ['31', { decoded: '3600W' }]
      ])
    );
  }

  decodeToDescription(code) {
    this.validateCode(code);

    const decodedText = [];

    decodedText.push(`Machine_type: ${this.getDecodedValue('machine_type', code.substring(2, 3), code)}`);
    decodedText.push(`Voltage: ${this.getDecodedValue('voltage', code.substring(3, 4), code)}`);
    decodedText.push(`Frequency: ${this.getDecodedValue('frequency', code.substring(4, 5), code)}`);
    decodedText.push(`Power: ${this.getPower(code)}`);
    decodedText.push(`Cable_attachment_type: ${this.getDecodedValue('cable_attachment_type', code.substring(6, 7), code)}`);
    decodedText.push(`Cable_type: ${this.getDecodedValue('cable_type', code.substring(7, 8), code)}`);
    decodedText.push(`Color: ${this.getDecodedValue('color', code.substring(8, 10), code)}`);
    decodedText.push(`Pitcher_holder: ${this.getDecodedValue('pitcher_holder', code.substring(11, 12), code)}`);


    return decodedText.join('<br>');
  }

  validateCode(code) {
    // Check length
    if (code.length !== 12) {
      throw new Error('Invalid code length. Code must be 12 characters.');
    }

    // Check if code starts with "PM"
    if (code.substring(0, 2) !== 'PM') {
      throw new Error("Invalid code format. Code must start with 'PM'.");
    }

    // Validate each part of the code
    const validations = [
      { category: 'machine_type', position: [2, 3] },
      { category: 'voltage', position: [3, 4] },
      { category: 'frequency', position: [4, 5] },
      { category: 'cable_attachment_type', position: [6, 7] },
      { category: 'cable_type', position: [7, 8] },
      { category: 'color', position: [8, 10] },
      { category: 'pitcher_holder', position: [11, 12] }
    ];

    for (const validation of validations) {
      const value = code.substring(validation.position[0], validation.position[1]);
      const categoryMap = this.configurator.get(validation.category);

      if (!categoryMap.has(value)) {
        throw new Error(`Invalid ${validation.category} value '${value}'. ` + `Valid values are: ${[...categoryMap.keys()].join(', ')}`);
      }
    }
  }

  decodeToJson(code) {
    this.validateCode(code);
    let result = {
      description: this.decodeToDescription(code),
      machine_type: this.getDecodedValue('machine_type', code.substring(2, 3), code),
      voltage: this.getDecodedValue('voltage', code.substring(3, 4), code),
      frequency: this.getDecodedValue('frequency', code.substring(4, 5), code),
      power: this.getPower(code),
      cable_attachment_type: this.getDecodedValue('cable_attachment_type', code.substring(6, 7), code),
      cable_type: this.getDecodedValue('cable_type', code.substring(7, 8), code),
      color: this.getDecodedValue('color', code.substring(8, 10), code),
      pitcher_holder: this.getDecodedValue('pitcher_holder', code.substring(11, 12), code)
    };
    return result;
  }

  getPartDescription(code, category) {
    let key = '';
    switch (category) {
      case 'machine_type':
        key = code.substring(2, 3);
        break;
      case 'voltage':
        key = code.substring(3, 4);
        break;
      case 'frequency':
        key = code.substring(4, 5);
        break;
      case 'cable_attachment_type':
        key = code.substring(6, 7);
        break;
      case 'cable_type':
        key = code.substring(7, 8);
        break;
      case 'color':
        key = code.substring(8, 10);
        break;
      case 'pitcher_holder':
        key = code.substring(11, 12);
        break;
      default:
        throw new Error(`Invalid category '${category}'.`);
    }

    const categoryMap = this.configurator.get(category);
    if (!categoryMap) {
      throw new Error(`Category '${category}' not found.`);
    }

    const value = categoryMap.get(key);
    if (!value) {
      throw new Error(`Key '${key}' not found in category '${category}'.`);
    }

    return value.decoded;
  }

  getDecodedValue(category, key, code) {
    const categoryMap = this.configurator.get(category);
    if (!categoryMap) {
      throw new Error(`Category '${category}' not found.`);
    }

    const value = categoryMap.get(key);
    if (!value) {
      throw new Error(`Key '${key}' not found in category '${category}'.`);
    }

    if (category === 'cable_type' && ['B', 'I', 'J'].includes(key)) {
      const machineType = code.substring(2, 3);
      const voltage = code.substring(3, 4);

      let res = '';

      if (key === 'B') {
        if (machineType === 'G' && voltage === '1') res = 'B - NEMA 5-15';
        if (machineType === 'G' && voltage === '2') res = 'B - NEMA 6-15';
        if (machineType === 'J' && voltage === '2') res = 'B - NEMA 6-20';
        if (machineType === 'J' && voltage === '3') res = 'B - NEMA L21-20';

        return res;
      }

      if (key === 'I') {
        if (machineType === 'G') return 'I - AS3112 10A';
        if (machineType === 'J') return 'I - AS3112 15A';
      }

      if (key === 'J') {
        if (machineType === 'G') return 'J - SN 441011 10A';
        if (machineType === 'J') return 'J - SN 441011 16A';
      }
    }

    return value.decoded;
  }

  getPower(code) {
    this.validateCode(code);

    const machineType = code.substring(2, 3);
    const frequency = code.substring(4, 5);

    if (machineType === 'G') {
      if (code.includes('10')) return '30W';
      if (code.includes('20')) return '50W';
    } else if (machineType === 'J') {
      if (frequency === '0') {
        return '2430W';
      } else if (frequency === '1') {
        return '2980W';
      }
    }

    return null;
  }

  getBoilerWattage(code) {
    this.validateCode(code);

    // boiler wattage is only for jacks, gregs do not have a boiler
    if (code.includes("PMJ")) {
      if (code.includes("20")) return "2400W"
      if (code.includes("21")) return "2950W"
      if (code.includes("30")) return "2950W"
      if (code.includes("31")) return "3600W"
    }

    return null;
  }

  getCurrentMachineType(code) {
    return code.substring(2, 3);
  }

  getCurrentVoltage(code) {
    return code.substring(3, 4);
  }

  getCurrentPitcherHolder() {
    return this._currentCode?.substring(11, 12);
  }
}

export default PerfectMooseDecoder;